module.exports = __webpack_public_path__ + "img/GalaChips[GYRI]-icon.4be5e6e.png";